import { useEffect, useState } from 'react';
import { PHOTOS } from '../content/siteContent';
import Seo from "./Seo";

const PER_PAGE = 4;

export default function Photos() {
    const photos = PHOTOS;
    const [page, setPage] = useState(0);
    const [dir, setDir] = useState('next');
    const [lb, setLb] = useState(null);

    const pages = [];
    for (let i = 0; i < photos.length; i += PER_PAGE) pages.push(photos.slice(i, i + PER_PAGE));
    const total = pages.length || 1;
    const cur = Math.min(page, total - 1);

    const go = (i) => { if (i < 0 || i > total - 1 || i === cur) return; setDir(i > cur ? 'next' : 'prev'); setPage(i); };

    useEffect(() => {
        const onKey = (e) => { if (e.key === 'Escape') setLb(null); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, []);

    // Local paths (e.g. "/album/x.jpg") resolve against the app's base URL so
    // they work at the root or under a subpath. Full http(s)/data URLs pass through.
    const resolveSrc = (src) => {
        if (!src) return src;
        if (/^(https?:)?\/\//i.test(src) || src.startsWith('data:')) return src;
        const base = process.env.PUBLIC_URL || '';
        return src.startsWith('/') ? base + src : `${base}/${src}`;
    };

    const renderPh = (p, cls) => p.src
        ? <img className={cls} src={resolveSrc(p.src)} alt={p.caption || ''} />
        : <span className={cls} style={{ background: p.color || '#e9dfd4' }} />;

    return (
        <main className="cx-page"><div className="cx-col">
            <Seo title="the album" path="/photos"
                 description="A glimpse into Ethan's/Aris's camera roll." />

            <div className="al-head">
                <h1>the album</h1>
                <p className="intro">A glimpse into my camera roll.</p>
            </div>

            {photos.length > 0 && (
                <>
                    <div className="al-book">
                        <div className={`al-leaf ${dir === 'next' ? 'dir-next' : 'dir-prev'}`} key={cur}>
                            <div className="al-grid">
                                {(pages[cur] || []).map((p, i) => (
                                    <button className="al-print" key={i} onClick={() => setLb(p)}>
                                        {renderPh(p, 'al-ph')}
                                        <span className="al-cap">{p.caption}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="al-controls">
                        <button className="al-nav" onClick={() => go(cur - 1)} disabled={cur === 0} aria-label="Previous page">←</button>
                        <div className="al-dots">
                            {pages.map((_, i) => (
                                <button key={i} className={`al-dot ${i === cur ? 'on' : ''}`} onClick={() => go(i)} aria-label={`Page ${i + 1}`} />
                            ))}
                        </div>
                        <button className="al-nav" onClick={() => go(cur + 1)} disabled={cur === total - 1} aria-label="Next page">→</button>
                    </div>
                    <p className="al-label">page {cur + 1} of {total}</p>
                </>
            )}

            {lb && (
                <div className="al-lb" onClick={(e) => { if (e.target.classList.contains('al-lb')) setLb(null); }}>
                    <button className="al-lb-close" onClick={() => setLb(null)} aria-label="Close">×</button>
                    <div className="al-lb-frame">{renderPh(lb, 'al-lb-img')}</div>
                    <div className="al-lb-cap">{lb.caption}</div>
                </div>
            )}
        </div></main>
    );
}